import Vue from 'vue'
import App from './App.vue'
import { router } from './router/index'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/base/elementui-custom.scss'
import './assets/icon/iconfont.css'
import './assets/icon/iconfont'
import 'xiaoi-aicc-dev/src/assets/icon/iconfont'
import { http } from './utils/http'
import authUtis from './utils/authUtis'
import VueI18n from 'vue-i18n'
import zhCN from './locale/zh_CN'
import enUS from './locale/en_US'
import VideoPlayer from 'vue-video-player'
import echart from 'echarts'
import china from 'echarts/map/json/china.json'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import globalVaribale from './utils/globalVariable'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import envUtils from './utils/envUtils'
import VCharts from 'v-charts'

// 动态网址等配置
window.$envUtils = envUtils

Vue.prototype.$echarts = echart
echart.registerMap('china', china)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.prototype.$http = http
Vue.prototype.$authUtis = authUtis
Vue.prototype.$global = globalVaribale

Vue.use(Element, { zIndex: 1500 })
Vue.use(Viewer)
Vue.use(VueI18n)
Vue.use(VCharts)
Vue.use(VideoPlayer)
Vue.config.productionTip = false

NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3
})

// const router = routerData.router
var i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
